import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { TrendingUp } from 'lucide-react';

export const ActivityChart = ({ data }) => {
  return (
    <Card className="bg-light/5 border-gold/20">
      <CardHeader>
        <CardTitle className="text-white flex items-center gap-2">
          <TrendingUp className="w-5 h-5 text-gold" />
          Évolution sur 30 jours
        </CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#333" />
            <XAxis 
              dataKey="date" 
              stroke="#999"
              style={{ fontSize: '12px' }}
            />
            <YAxis 
              stroke="#999"
              style={{ fontSize: '12px' }}
            />
            <Tooltip 
              contentStyle={{ 
                backgroundColor: '#1a1a1a', 
                border: '1px solid #d4b886',
                borderRadius: '4px'
              }}
              labelStyle={{ color: '#d4b886' }}
            />
            <Legend />
            <Line 
              type="monotone" 
              dataKey="contacts" 
              stroke="#d4b886" 
              strokeWidth={2}
              name="Contacts"
              dot={{ fill: '#d4b886' }}
            />
            <Line 
              type="monotone" 
              dataKey="appointments" 
              stroke="#4dffb8" 
              strokeWidth={2}
              name="Rendez-vous"
              dot={{ fill: '#4dffb8' }}
            />
          </LineChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};
